import { SlidersHorizontal } from 'lucide-react';

import { RetryDeployPeriod } from '@/react/edge/edge-stacks/components/RetryDeployPeriod';
import { RetryDeployToggle } from '@/react/edge/edge-stacks/components/RetryDeployToggle';
import { PrivateRegistryFieldsetWrapper } from '@/react/edge/edge-stacks/ItemView/EditEdgeStackForm/PrivateRegistryFieldsetWrapper';

import { SwitchField } from '@@/form-components/SwitchField';
import { Card } from '@@/primitives/Card';

import { ArtifactConfig } from '../../type';

export function RegistryConfiguration({
  values,
  setFieldValue,
  onRegistryError,
}: {
  values: ArtifactConfig;
  setFieldValue: <K extends keyof ArtifactConfig>(
    f: K,
    v: ArtifactConfig[K]
  ) => void;
  onRegistryError: (message: string) => void;
}) {
  return (
    <Card.Container>
      <Card.Header title="Registry configuration" icon={SlidersHorizontal} />
      <Card.Body>
        <div className="form-group">
          <div className="col-sm-12">
            <SwitchField
              checked={values.prePullImage}
              name="prePullImage"
              label="Pre-pull images"
              tooltip="When enabled, the image will be pre-pulled before deployment is started. This is useful in scenarios where the image download may be delayed or intermittent and would subsequently cause the deployment to fail"
              labelClass="col-sm-3 col-lg-2"
              onChange={(value) => setFieldValue('prePullImage', value)}
              data-cy="pre-pull-images-switch"
            />
          </div>
        </div>

        <RetryDeployToggle
          onChange={(value) => setFieldValue('retryDeploy', value)}
          value={values.retryDeploy}
        />

        {values.retryDeploy && <RetryDeployPeriod />}

        <PrivateRegistryFieldsetWrapper
          value={values.registryId}
          onChange={(value) => setFieldValue('registryId', value)}
          values={{}}
          onFieldError={onRegistryError}
          isGit
        />
      </Card.Body>
    </Card.Container>
  );
}
